import { HOME_SET_UPCOMING_ASSIGNMENT_COUNTS } from '@core/constants/actions';
import { HomeUpcomingAssignmentCount } from '@core/types/state';

export const setUpcomingAssignmentCounts = (
  assignmentCounts: HomeUpcomingAssignmentCount[]
): {
  type: typeof HOME_SET_UPCOMING_ASSIGNMENT_COUNTS;
  upcomingAssignmentCounts: HomeUpcomingAssignmentCount[];
} => ({
  type: HOME_SET_UPCOMING_ASSIGNMENT_COUNTS,
  upcomingAssignmentCounts: assignmentCounts.map((item) => ({
    assignmentStatus: item.assignmentStatus,
    count: Math.max(0, Number(item.count) || 0),
  })),
});

export default setUpcomingAssignmentCounts;
